module.exports = __webpack_public_path__ + "img/stor_wrapbg5.8ce89b32.png";